var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('iframe',{staticStyle:{"position":"absolute","top":"0","left":"0","bottom":"0","right":"0"},attrs:{"id":"iframe","width":"100vw","height":"100vh","src":_vm.src,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }